import instaclustrComponent from "./Components";

export class Component extends instaclustrComponent {
    constructor(name, node) {
        super(name, node);
    }
    init() {
        console.log(this.name);

        // Breakpoint references
        let sm = 576,
            md = 768,
            lg = 992,
            xl = 1200;

        // Viewport width helper function
        function viewport() {
            let e = window,
                a = 'inner';
            if (!('innerWidth' in window)) {
                a = 'client';
                e = document.documentElement || document.body;
            }
            return { width: e[ a + 'Width' ], height : e[ a + 'Height'] };
        }

        let vpWidth       = viewport().width;

        // Close alert bar
        let $body     = $('body');
        let $header   = $('header');
        let $alertBar = $('.component-alert-bar');

        $('#alert-close').on('click', function(){
            $alertBar.css('display', 'none');
            $body.removeClass('has-alert-bar');
            $header.css({ "top" : 0 });
        });

        function scrollCheck() {
            let $scrollTop = $(window).scrollTop();
            if ($scrollTop > 0 && $body.hasClass('has-alert-bar')) {
                $body.addClass('scrolled');
                if ($scrollTop < 46 && $scrollTop > -1) {
                    if ($body.hasClass('logged-in')) {
                        if (vpWidth > 782) {
                            $header.css({ "top" : 77 - $scrollTop });
                        } else {
                            $header.css({ "top" : 91 - $scrollTop });
                        }
                    } else {
                        $header.css({ "top" : 45 - $scrollTop });
                    }
                } else if ($scrollTop > 46) {
                    if ($body.hasClass('logged-in')) {
                        if (vpWidth > 782) {
                            $header.css({ "top" : 32 });
                        } else {
                            $header.css({ "top" : 46 });
                        }
                    } else {
                        $header.css({ "top" : 0 });
                    }
                }
            } else {
                $body.removeClass('scrolled');
                //$header.css({"top" : $scrollTop});
            }
        }

        function headerCheck() {
            let $scrollTop = $(window).scrollTop();
            if ($scrollTop === 0 && $body.hasClass('has-alert-bar')) {
                if ($body.hasClass('logged-in')) {
                    if (vpWidth > 782) {
                        $header.css({ "top" : 77 });
                    } else {
                        $header.css({ "top" : 91 });
                    }
                } else {
                    $header.css({ "top" : 45 });
                }
            }
        }

        scrollCheck();
        headerCheck();

        // Check for scrolling to adjust main header position
        $(window).scroll(function() {
            scrollCheck();
            headerCheck();
        });



    }
}